module.exports = __webpack_public_path__ + "img/search-remove.f0f45198.svg";